var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3016 3.84325C22.5428 4.01024 22.6875 4.28485 22.6875 4.57801V17.0468C22.6875 17.4179 22.4574 17.7481 22.1123 17.878L15.8779 20.253C15.685 20.3272 15.4734 20.3309 15.2805 20.2641L8.45605 17.993L2.51855 20.2567C2.24395 20.3606 1.93594 20.3235 1.69473 20.1565C1.45352 19.9895 1.3125 19.7149 1.3125 19.4218V6.95301C1.3125 6.58192 1.53887 6.25164 1.8877 6.12176L8.12207 3.74676C8.31504 3.67254 8.52656 3.66883 8.71953 3.73563L15.5439 6.00672L21.4814 3.74305C21.7561 3.63914 22.0641 3.67625 22.3053 3.84325H22.3016ZM3.09375 7.56532V18.1304L7.54688 16.4345V5.86942L3.09375 7.56532ZM14.6719 18.186V7.595L9.32812 5.81375V16.4048L14.6719 18.186ZM16.4531 18.1304L20.9062 16.4345V5.86942L16.4531 7.56532V18.1304Z",
    fill: "#526077"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.35b089f905806879e545702450c6d381.svg";
export { ForwardRef as ReactComponent };